import { FormatNumber } from '@chakra-ui/react';
import type { StatsMetric } from '@fluenceur/types';

interface MetricValueProps {
  metric?: StatsMetric;
  formatAsPercent?: boolean;
  /** Maximum fraction digits for currency formatting */
  maximumFractionDigits?: number;
}

/**
 * The number of a metric, formatted in the UI locale: a percentage, an amount in
 * its own currency, or the server's formatted value. An em dash when there is none.
 * Inline content only: the caller owns the typography.
 */
export const MetricValue: React.FC<MetricValueProps> = ({
  metric,
  formatAsPercent,
  maximumFractionDigits,
}) => {
  if (!metric) return <>—</>;

  if (formatAsPercent) {
    return (
      <FormatNumber
        value={metric.value / 100}
        style="percent"
        minimumFractionDigits={0}
        maximumFractionDigits={2}
      />
    );
  }

  if (metric.currency) {
    return (
      <FormatNumber
        value={metric.value}
        style="currency"
        currency={metric.currency}
        currencyDisplay="narrowSymbol"
        {...(maximumFractionDigits !== undefined && { maximumFractionDigits })}
      />
    );
  }

  return <>{metric.formatted}</>;
};
